import React, { useState } from 'react';
import { StyledContentList, VideoList, VideoListContainer } from './ContentList.styles';
import Header from './components/Header/Header';
import ContentItemGrid from '../ContentItemGrid/ContentItemGrid';
import ContentItemCarousel, {
    CARD_TYPE as CAROUSEL_CARD_TYPE,
} from '../ContentItemCarousel/ContentItemCarousel';
import { isInSweden } from '../../utils/environment';
import PromotionGrid from '../PromotionGrid/PromotionGrid';

export const CARD_TYPE = {
    CONTENT_ITEM: 'CONTENT_ITEM',
    PROMOTION: 'PROMOTION',
};

const ContentList = (props) => {
    const {
        id,
        items,
        cardType = CARD_TYPE.CONTENT_ITEM,
        withDivider,
        standalone,
        vtp,
        containerId,
        regTestSpec,
        headerText,
        url,
        expandable,
        allItemsVisible,
        deletableItems,
        location,
        presentation,
        preferredAccessVersion,
        onItemClick,
        continueWatchingIsActive,
        continueWatchingItems,
        onDeleteItems,
        showAccessibilityLinks = false,
        isListType = true,
        className,
    } = props;

    const [expanded, toggleExpanded] = useState(false);
    const [editModeActivated, toggleEditMode] = useState(false);
    const [markedAsDeleted, setMarkedAsDeleted] = useState([]);

    if (items.length <= 0) {
        return null;
    }

    const NUMBER_OF_ITEMS_LIMIT = 24;

    const changeLayout = (id) => {
        toggleExpanded(!expanded);
    };

    const onEditDone = () => {
        onDeleteItems(markedAsDeleted);
        toggleEditMode(false);
    };

    const onEditModeActivated = () => {
        toggleEditMode(true);
    };

    const getTotalItems = () => {
        if (items.length > NUMBER_OF_ITEMS_LIMIT) {
            return items.slice(0, NUMBER_OF_ITEMS_LIMIT - 1);
        }

        return items;
    };

    const onMarkedAsDeleted = (deleteItem) => {
        let result = markedAsDeleted;

        const index = markedAsDeleted.findIndex((markedItem) => markedItem.videoId === deleteItem.videoId);

        if (index > -1) {
            result = markedAsDeleted.filter((markedItem) => markedItem.videoId !== deleteItem.videoId);
        } else {
            result.push(deleteItem);
        }

        setMarkedAsDeleted(result);
    };

    return (
        <StyledContentList
            withDivider={withDivider}
            standalone={standalone}
            vtp={vtp}
            id={containerId}
            className={className}
            data-rt="slidable-list"
            data-rt-spec={regTestSpec}
            data-helix-type={isListType ? 'list' : null}
            aria-label={headerText}
        >
            <Header
                id={id}
                regTestSpec={regTestSpec}
                url={url}
                text={headerText}
                expanded={expanded}
                expandable={expandable}
                allItemsVisible={allItemsVisible}
                changeLayout={changeLayout}
                showEditButtons={deletableItems}
                markedAsDeleted={markedAsDeleted}
                onEditDone={onEditDone}
                onEditModeActivated={onEditModeActivated}
                showAccessibilityLinks={showAccessibilityLinks}
            />
            <VideoList expanded={expanded}>
                <VideoListContainer expanded={expanded}>
                    {cardType === CARD_TYPE.CONTENT_ITEM && (
                        <>
                            {expanded && (
                                <ContentItemGrid
                                    items={getTotalItems()}
                                    id={id}
                                    editModeActivated={editModeActivated}
                                    location={location}
                                    presentation={presentation}
                                    preferredAccessVersion={preferredAccessVersion}
                                    onItemClick={onItemClick}
                                    onMarkItemAsDeleted={onMarkedAsDeleted}
                                    continueWatchingIsActive={continueWatchingIsActive}
                                    continueWatchingItems={continueWatchingItems}
                                    markedAsDeleted={markedAsDeleted}
                                    isInSweden={isInSweden}
                                />
                            )}
                            {!expanded && (
                                <ContentItemCarousel
                                    dataRt="content-item-carousel"
                                    items={getTotalItems()}
                                    id={id}
                                    editModeActivated={editModeActivated}
                                    location={location}
                                    presentation={presentation}
                                    preferredAccessVersion={preferredAccessVersion}
                                    onItemClick={onItemClick}
                                    onMarkItemAsDeleted={onMarkedAsDeleted}
                                    continueWatchingIsActive={continueWatchingIsActive}
                                    continueWatchingItems={continueWatchingItems}
                                    markedAsDeleted={markedAsDeleted}
                                    isInSweden={isInSweden}
                                />
                            )}
                        </>
                    )}
                    {cardType === CARD_TYPE.PROMOTION && (
                        <>
                            {expanded && (
                                <PromotionGrid
                                    mainGenres={items}
                                    onItemClick={onItemClick}
                                    showAccessibilityLinks={false}
                                    withDivider={false}
                                />
                            )}

                            {!expanded && (
                                <ContentItemCarousel
                                    id="genre-grid-start-page"
                                    items={items}
                                    cardType={CAROUSEL_CARD_TYPE.PROMOTION}
                                    onItemClick={onItemClick}
                                />
                            )}
                        </>
                    )}
                </VideoListContainer>
            </VideoList>
        </StyledContentList>
    );
};

export default ContentList;
